export enum TransportationMode {
  MotorVehicle = 1,
  PublicTransport = 2,
}
